import Text from './Text'
import Select from './Select'
import File from './File'
import Email from './Email'
import Checkbox from './Checkbox'
import Title from './Title'
import Captcha from './Captcha'
import Hidden from './Hidden'
import HiddenCountry from './HiddenCountry'
import HiddenGetUrlParam from './HiddenGetUrlParam'
import HiddenCheckboxTerms from './HiddenCheckboxTerms'
import Spacer from '../common/Spacer'
import Date from './Date'
import SelectSearch from './SelectSearch'

export default {
  Text,
  Select,
  File,
  Email,
  Checkbox,
  Title,
  Captcha,
  Hidden,
  HiddenCountry,
  HiddenGetUrlParam,
  HiddenCheckboxTerms,
  Spacer,
  Date,
  SelectSearch
}
